module.exports = __webpack_public_path__ + "img/logo.ba014901.png";